import Container from "./containers/Container";

const Users = {
  Container,
};

export { Users };